import { render, staticRenderFns } from "./OfferingTerms.vue?vue&type=template&id=31dea9b0&scoped=true"
import script from "./OfferingTerms.vue?vue&type=script&lang=js"
export * from "./OfferingTerms.vue?vue&type=script&lang=js"
import style0 from "./OfferingTerms.vue?vue&type=style&index=0&id=31dea9b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dea9b0",
  null
  
)

export default component.exports